module.exports = __webpack_public_path__ + "img/end4.af50226c.svg";